import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import { useState, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { sandhillsRequest, focusErroredField, insertURLParameter } from '@Components/Utilities/SandhillsUtility';
import Button from '@mui/material/Button';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ValidationErrors from '@Components/Shared/ValidationErrors';
import { ValidationRules, ruleRunner, run } from '@Components/Utilities/Validation';
import TextField from '@Components/Shared/Controls/TextField';
import Typography from '@mui/material/Typography';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import ReplyIcon from '@mui/icons-material/Reply';


const MediaUpload = loadable(() => import('@Components/Shared/MediaUpload'));

const Quote = (props) => {
    const windowSize = useWindowSize();
    const [priceQuoteID, setPriceQuoteID] = useState(null);
    const [success, setSuccess] = useState(props.IsAccepted);
    const routes = useRecoilValue(atoms.routes);
    const [directMessages, setDirectMessages] = useState(props.DirectMessages);
    const [submitted, setSubmitted] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState(false);
    const [media, setMedia] = useState([]);
    const inputReferences = useRef({});
    const [priceQuotes, setPriceQuotes] = useState(props.QuotePrices.Quotes);
    const saveAcceptedQuoteRequest = () => {
        sandhillsRequest({
            url: props.QuoteRequestAccepted,
            method: 'post',
            data: {
                EquipmentMessageID: props.EquipmentMessageID,
                EquipmentMessagePriceQuoteID: priceQuoteID,
                AcceptedBidCRMID: props.CompanyCRMID
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then((data) => {
            if (data.Success) {
                setSuccess(true);
                let newPriceQuotes = [...priceQuotes]
                newPriceQuotes = newPriceQuotes.filter(quote => quote.EquipmentMessagePriceQuoteID == priceQuoteID);
                setPriceQuotes(newPriceQuotes);
            }
        });
    };
    const sendDirectMessage = (e) => {
        e.preventDefault();
        let errors = run(formData, [
            ruleRunner('Message', 'Message', ValidationRules.required),
        ]);
        focusErroredField(errors, inputReferences);
        setSubmitted(false);

        if (Object.keys(errors).length <= 0) {
            setMessageSuccess(false);
            setDisableSubmit(true);
            onSubmit();
        }
    }
    const onChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData(previousState => {
            return { ...previousState, [name]: value };
        });
    };
    const [formData, setFormData] = useState({
        MediaUpload: props.ReplyModel.MediaUpload,
        Message: props.ReplyModel.Message
    });

    const onSubmit = () => {
        sandhillsRequest({
            url: routes.QuoteMessageSave,
            method: 'post',
            data: {
                ReceiverCRMID: props.ReplyModel.SendToCRMID,
                ParentMessageID: props.ReplyModel.ParentMessageID,
                Message: formData.Message,
                MediaUpload: formData.MediaUpload,
                OriginatingMessageID: props.OriginatingMessageID,
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then((data) => {
            if (data.Success) {
                setFormData({
                    MediaUpload: '',
                    Message: ''
                });
                setMessageSuccess(true);
                let mediaIds = data.MediaIDs && data.MediaIDs.length > 0 ? data.MediaIDs.join('|') : '';
                let getMediaURL = insertURLParameter(routes.GetMedia, "MediaIds", mediaIds);
                sandhillsRequest({
                    url: getMediaURL,
                    errorHandling: {
                        useConsole: false,
                        useAlert: false
                    }
                }).then((response) => {
                    let mediaUpload = [];
                    if (response && response.length > 0) {
                        newMedia = response.map(media => {
                            return {
                                src: decodeURIComponent(media.MediaUrl),
                                mediaId: media.MediaId,
                                mediaUrl: decodeURIComponent(media.MediaUrl),
                                fileName: media.MediaFileName,
                                loaded: true
                            };
                        });
                        mediaUpload = response.map(media => {
                            return {
                                MediaID: media.MediaId,
                                FileUrl: decodeURIComponent(media.MediaUrl),
                                FileName: formData.MediaUpload.filter(file => file.MediaID == media.MediaId)[0].FileName,
                            };
                        });
                    }
                    setMedia([]);
                    setFormData(previousState => {
                        return {
                            ...previousState,
                            MediaUpload: mediaUpload
                        };
                    });
                    let newDirectMessage = {
                        MessageID: data.MessageID,
                        OriginatingMessageID: props.OriginatingMessageID,
                        ParentMessageID: props.ReplyModel.ParentMessageID,
                        Name: data.Name,
                        Message: formData.Message,
                        Received: data.Received,
                        MessageClass: 'sent',
                        RecieverCRMID: props.ReplyModel.SendToCRMID,
                        SenderCRMID: data.SenderCRMID,
                        MediaUpload: mediaUpload
                    }
                    let newDirectMessages = [...directMessages];
                    newDirectMessages.push(newDirectMessage);
                    setDirectMessages(newDirectMessages);
                });
            }
        })
    };

    const onPriceSelected = (e) => {
        let newPriceQuoteID = e.currentTarget.getAttribute('value');
        if (newPriceQuoteID != null) {
            if (priceQuoteID == newPriceQuoteID) {
                setPriceQuoteID(null);
                setPriceQuotes(props.QuotePrices.Quotes);
            }
            else {
                setPriceQuoteID(newPriceQuoteID);
                let priceQuote = priceQuotes.filter(quote => quote.EquipmentMessagePriceQuoteID == newPriceQuoteID)[0];
                setPriceQuotes([priceQuote]);
            }
        }
        else {
            setPriceQuotes(props.QuotePrices.Quotes)
        }
    }
    //focus on message form element
    const focusOnMessage = () => {
        if (inputReferences.current['Message']) {
            inputReferences.current['Message'].focus();
            inputReferences.current['Message'].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    return (
        <>
            <div className='quote-message'>
                <div className='quote-wrap'>
                    {!windowSize.isMobile &&
                        <div className='quote-reply-button'>
                            <Button color="primary" ref={(element) => inputReferences.current[`Message`] = element} variant="contained" startIcon={<ReplyIcon />} onClick={focusOnMessage} className='buy-now btn btn-primary'>{translator.translate('sandhills.reply')}</Button>
                        </div>}
                    <div className='quote-section'>
                        <div className='quote-company-info'>
                            {props.CompanyLogoURL &&
                                <div className='quote-dealer-logo'>
                                    <img tabindex='0' src={props.CompanyLogoURL} className='dealer-logo' alt={props.CompanyName ?? props.ContactName + "Company Logo"} />
                                </div>}
                            <div className='quote-dealer-name'>
                                {props.CompanyName && <h3>{props.CompanyName}</h3>}
                                <h3>{props.ContactName}</h3>
                                <div className='quote-message'>
                                    <span>{props.Message}</span>
                                </div>
                            </div>

                            {success &&
                                <div className='quote-accepted'>
                                    <div className='accepted-price-quote'>
                                        <div className='accepted-price-label'><span><strong>{translator.translate('sandhills.acceptedpricequote')}:</strong></span></div>
                                        {priceQuotes.map((quote) =>
                                            <div>
                                                {quote.QuoteTypeID == 1 ?
                                                    <>
                                                        <Typography variant='body1'>{quote.QuoteCurrencyCode}{quote.QuoteAmount}/{quote.QuoteAmountLabel}</Typography>
                                                        <Typography variant='body2'>
                                                            {quote.LoanDuration} {translator.translate('sandhills.monthlease')}/{quote.QuoteCurrencyCode}{quote.DownPayment} {translator.translate('sandhills.crm.dscrm.down')}
                                                        </Typography>
                                                    </> :
                                                    <>
                                                        <Typography variant='body1'>{quote.QuoteCurrencyCode}{quote.QuoteAmount}</Typography>
                                                        <Typography variant='body2'>{quote.QuoteAmountLabel}</Typography>
                                                    </>}
                                            </div>)}

                                    </div>
                                </div>}
                        </div>
                    </div>
                    {windowSize.isMobile &&
                        <div className='quote-reply-button'>
                            <Button color="primary" variant="contained" startIcon={<ReplyIcon />} onClick={focusOnMessage} className='buy-now btn btn-primary'>{translator.translate('sandhills.reply')}</Button>
                        </div>}
                    <div>
                        {priceQuotes && priceQuotes.length > 0 && !props.IsAccepted && !success &&
                            <div className='quote-price-options'>
                                <div><span><strong>{props.ChooseOptionLabel}:</strong></span></div>
                                <div className='quote-prices-toggle'>
                                    {priceQuotes.map((quote) =>
                                        <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); onPriceSelected() } }} className={quote.QuoteTypeID == 1 ? 'lease-price' : 'rental-price'} key={quote.EquipmentMessagePriceQuoteID} onClick={onPriceSelected} value={quote.EquipmentMessagePriceQuoteID}>
                                            {quote.QuoteTypeID == 1 ?
                                                <>
                                                    <Typography variant='body1'>{quote.QuoteCurrencyCode}{quote.QuoteAmount}/{quote.QuoteAmountLabel}</Typography>
                                                    <Typography variant='body2'>
                                                        {quote.LoanDuration} {translator.translate('sandhills.monthlease')}/{quote.QuoteCurrencyCode}{quote.DownPayment} {translator.translate('sandhills.crm.dscrm.down')}
                                                    </Typography>
                                                </> :
                                                <>
                                                    <Typography variant='body1'>{quote.QuoteCurrencyCode}{quote.QuoteAmount}</Typography>
                                                    <Typography variant='body2'>{quote.QuoteAmountLabel}</Typography>
                                                </>}
                                        </a>

                                    )}

                                    {priceQuoteID != null && !success && !props.IsAccepted &&
                                        <div className='accept-quote-btn'>
                                            <Button color="primary" variant="contained" startIcon={<CheckBoxIcon />} onClick={saveAcceptedQuoteRequest} className='buy-now btn btn-primary'>{translator.translate('sandhills.acceptquote')}</Button>
                                        </div>}
                                </div>
                            </div>}
                    </div>
                </div>
            </div>
            <div className='quote-wrap'>
                <div className='quote-direct-messages'>
                    {directMessages && directMessages.length > 0 && directMessages.map((msg) =>
                        <div key={msg.MessageID} className={'quote-wrap' + ' ' + msg.MessageClass}>
                            <div className='quote-message-container'>
                                <div className='quote-message-info'>
                                    <span><strong>{msg.Name}</strong></span>
                                    <span>{msg.Received}</span>
                                </div>
                                <div className='quote-message'>
                                    <span>{msg.Message}</span>
                                </div>
                                {msg.MediaUpload && msg.MediaUpload.length > 0 &&
                                    <div className='quote-attachments'>
                                        {msg.MediaUpload.map((file) =>
                                            <div className='quote-attachment'>
                                                <a href={file.FileUrl} target='_blank' aria-label={file.FileName + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                                                    <i class="fa-solid fa-paperclip fa-sm" aria-hidden='true' />
                                                    <span>{file.FileName}</span>
                                                </a>
                                            </div>)}
                                    </div>}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className='quote-wrap'>
                <div className='quote-message-reply'>
                    <div className='quote-new-message'>
                        <form className={'contact-form-modal'} name='quoteMessageForm' onSubmit={sendDirectMessage}>
                            <ValidationErrors errors={validationErrors} />
                            <div className='form-main-content'>
                                <TextField
                                    id='Message'
                                    name='Message'
                                    value={formData.Message}
                                    placeholder='Enter your message here'
                                    type='textarea'
                                    label='Message'
                                    class='form-el text-area-container'
                                    inputClass='text-area quote-new-message-text'
                                    validationErrors={validationErrors.Message}
                                    ref={(element) => inputReferences.current[`Message`] = element}
                                    onFieldChanged={onChange}
                                />
                            </div>
                        </form>
                    </div>
                    <div className='quote-new-message quote-buttons'>
                        <MediaUpload
                            id='media'
                            name='media'
                            containerClassName='stolen-equipment-input-full'
                            buttonText={<span><i class="fa-solid fa-paperclip fa-lg" aria-hidden='true' /><TranslationText tKey='sandhills.attachdocument' /></span>}
                            label={<TranslationText tKey='sandhills.attachdocument' />}
                            labelClassName='hidden'
                            maxPhotoUpload={5}
                            media={media}
                            mediaType='file'
                            onChange={(media) => {
                                setMedia(media);
                                let mediaUpload = media.map(file => {
                                    return {
                                        MediaID: file.mediaId,
                                        FileUrl: file.mediaUrl,
                                        FileName: file.fileName,
                                    };
                                });
                                setFormData(previousState => {
                                    return {
                                        ...previousState, MediaUpload: mediaUpload
                                    };
                                });
                            }}
                        />
                        <a className='buy-btn send' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); sendDirectMessage() } }} onClick={sendDirectMessage}>
                            <i class="fa-solid fa-paper-plane fa-sm" aria-hidden='true' /><span><TranslationText tKey='sandhills.sendmessage' /></span>
                        </a>
                    </div>
                </div>
            </div>
        </>);
}
export default Quote;